import React from "react";

function ChevronDownDoubleIcon({ fill, ...restProps }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill={fill ?? ""}
      xmlns="http://www.w3.org/2000/svg"
      {...restProps}
    >
      <path
        d="M6.67 5.061c-.222.081-.42.248-.542.455-.091.156-.108.23-.108.484s.016.328.107.48c.135.226 5.241 5.325 5.433 5.425.1.052.227.073.44.073s.34-.021.44-.073c.192-.1 5.298-5.199 5.433-5.425.091-.152.107-.226.107-.48s-.017-.328-.108-.484a1.003 1.003 0 0 0-1.215-.451c-.178.059-.413.281-2.427 2.289L12 9.578 9.77 7.354c-2.014-2.008-2.249-2.23-2.427-2.289a1.015 1.015 0 0 0-.673-.004m0 7c-.222.081-.42.248-.542.455-.091.156-.108.23-.108.484s.016.328.107.48c.135.226 5.241 5.325 5.433 5.425.1.052.227.073.44.073s.34-.021.44-.073c.192-.1 5.298-5.199 5.433-5.425.091-.152.107-.226.107-.48s-.017-.328-.108-.484a1.003 1.003 0 0 0-1.215-.451c-.178.059-.413.281-2.427 2.289L12 16.578l-2.23-2.224c-2.014-2.008-2.249-2.23-2.427-2.289a1.015 1.015 0 0 0-.673-.004"
        fill-rule="evenodd"
        fill={fill ?? ""}
      />
    </svg>
  );
}

export default ChevronDownDoubleIcon;
